import { render, staticRenderFns } from "./hearing-loss-classification-results.vue?vue&type=template&id=6193e788&"
import script from "./hearing-loss-classification-results.vue?vue&type=script&lang=js&"
export * from "./hearing-loss-classification-results.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports